import { Component, computed, input } from '@angular/core';
import { formatCountdown } from '../../domain/format';
import { injectNow } from '../../services/clock';

// Compte a rebours jusqu'a un instant ISO 8601.
@Component({
  selector: 'app-countdown',
  styleUrl: './countdown.scss',
  templateUrl: './countdown.html',
})
export class Countdown {
  readonly until = input.required<string>();
  readonly label = input.required<string>();
  readonly compact = input(false);

  private readonly now = injectNow();
  protected readonly remaining = computed(() =>
    formatCountdown(Date.parse(this.until()) - this.now()),
  );
}
